import { queriesPayables } from "@query";

/**
 * The ids of the payables a payroll run holds.
 *
 * Exists because `searchPayableRows`' own `filter[payrollRunId]` is applied but
 * matches nothing, so the run's payables table cannot query the rows directly
 * (WIN-16127). `listPayables` carries the same filter, answers from the
 * canonical `Payable` — so it is correct the instant the run claims a payable,
 * with none of the row projection's ~70s lag — and its ids feed
 * `filter[id][anyOf]`, which does work.
 *
 * Delete this hook and pass `payrollRunId` straight to the table once WIN-16127
 * lands; nothing else about the table changes.
 */
export const useQueryPayrollRunPayableIds = (payrollRunId: string) => {
  const query = queriesPayables.listPayables.useQueryAll({
    filter: { payrollRunId: { eq: payrollRunId } }
  });

  return {
    ...query,
    payableIds: (query.flatData ?? [])
      .map(payable => payable.id)
      .filter((id): id is string => !!id)
  };
};
